import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import adminVehicleTypeService from '../api/adminVehicleTypeService';

// Keys
const KEYS = {
    all: ['vehicleTypes'],
    detail: (id) => ['vehicleType', id]
};

// Fetch all vehicle types
export const useVehicleTypes = () => {
    return useQuery({
        queryKey: KEYS.all,
        queryFn: () => adminVehicleTypeService.getAll().then((res) => res.data),
        staleTime: 5 * 60 * 1000 // 5 minutes
    });
};

// Fetch single vehicle type
export const useVehicleType = (id) => {
    return useQuery({
        queryKey: KEYS.detail(id),
        queryFn: () => adminVehicleTypeService.getById(id).then((res) => res.data),
        enabled: !!id,
        staleTime: 5 * 60 * 1000
    });
};

// Create a new vehicle type
export const useCreateVehicleType = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload) => adminVehicleTypeService.create(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: KEYS.all });
        }
    });
};

// Update an existing vehicle type
export const useUpdateVehicleType = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, payload }) => adminVehicleTypeService.update({ id, payload }),
        onSuccess: (_, { id }) => {
            queryClient.invalidateQueries({ queryKey: KEYS.all });
            queryClient.invalidateQueries({ queryKey: KEYS.detail(id) });
        }
    });
};

// Delete a vehicle type
export const useDeleteVehicleType = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => adminVehicleTypeService.delete(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: KEYS.all });
        }
    });
};
